import React from 'react';

const FormatItalic = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.33333 3.33333V5.83333H10.175L7.325 12.5H5V15H11.6667V12.5H9.825L12.675 5.83333H15V3.33333H8.33333Z" />
  </svg>
);

export default FormatItalic;
